module.exports = __webpack_public_path__ + "img/larry-puckett-logo.bcba23ad.jpg";